module.exports = __webpack_public_path__ + "static/img/3.476a9d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/3.png
// module id = Uh+R
// module chunks = 0